"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styles = __importStar(require("../styles/SweetAlertStyles"));
var Input = /** @class */function (_super) {
  __extends(Input, _super);
  function Input() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.inputElement = null;
    _this.setInputElementRef = function (element) {
      _this.inputElement = element;
    };
    return _this;
  }
  Input.prototype.componentDidMount = function () {
    if (this.props.type === 'input') {
      try {
        this.inputElement.focus();
      } catch (e) {
        // whoops
      }
    }
  };
  Input.prototype.render = function () {
    var _this = this;
    return react_1.default.createElement("div", {
      style: {
        position: 'relative'
      }
    }, this.props.inputType === 'textarea' ? react_1.default.createElement("textarea", {
      ref: this.setInputElementRef,
      rows: 4,
      className: "form-control",
      value: this.props.inputValue || '',
      onChange: function onChange(e) {
        return _this.props.onChangeInput(e);
      },
      onKeyDown: function onKeyDown(e) {
        return _this.props.onInputKeyDown(e);
      },
      placeholder: this.props.placeholder
    }) : react_1.default.createElement("input", {
      type: this.props.inputType,
      ref: this.setInputElementRef,
      className: "form-control",
      value: this.props.inputValue || '',
      onChange: function onChange(e) {
        return _this.props.onChangeInput(e);
      },
      onKeyDown: function onKeyDown(e) {
        return _this.props.onInputKeyDown(e);
      },
      placeholder: this.props.placeholder
    }), this.props.showValidationMessage && react_1.default.createElement("div", {
      style: styles.inputErrorIcon
    }, react_1.default.createElement("div", {
      style: Object.assign({}, styles.inputErrorIconBeforeAfter, styles.inputErrorIconBefore)
    }), react_1.default.createElement("div", {
      style: Object.assign({}, styles.inputErrorIconBeforeAfter, styles.inputErrorIconAfter)
    })));
  };
  return Input;
}(react_1.default.Component);
exports.default = Input;